import { Link } from 'react-router-dom';
import { FileText, Sparkles, Users } from 'lucide-react';
import { AppShell } from '@/components/layout/AppShell';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function DashboardUser() {
  // TODO(parecer-mvp): query de tarefas ativas, contratos recentes, métricas
  return (
    <AppShell role="users">
      <div className="max-w-5xl">
        <h1 className="font-serif text-display-lg">Bem-vindo</h1>
        <p className="text-muted-foreground mt-2">
          Descreva sua necessidade pra IA classificar e indicar advogados — ou suba um documento direto.
        </p>

        {/* Primary CTA — AI-first triage. */}
        <Card className="mt-8 border-accent/40 bg-accent/[0.04]">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Sparkles className="h-5 w-5 text-accent" /> Nova demanda
            </CardTitle>
            <CardDescription>
              Conte o que você precisa em linguagem natural. A IA classifica o tipo de serviço,
              identifica a especialidade jurídica e sugere advogados. Documento é opcional —
              funciona pra divórcio, consultoria, orientação preventiva, parecer, e mais.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild variant="accent" size="lg" className="w-full gap-2">
              <Link to="/app/demanda/nova">
                <Sparkles className="h-4 w-4" />
                Começar com IA
              </Link>
            </Button>
          </CardContent>
        </Card>

        <div className="mt-6 grid gap-6 sm:grid-cols-2">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <FileText className="h-5 w-5 text-muted-foreground" /> Tenho um documento
              </CardTitle>
              <CardDescription>Suba um PDF/DOCX e receba a pré-análise IA do contrato.</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild variant="outline" className="w-full">
                <Link to="/app/contratos/novo">Subir contrato</Link>
              </Button>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Users className="h-5 w-5 text-muted-foreground" /> Navegar advogados
              </CardTitle>
              <CardDescription>Marketplace com filtros de especialidade e preço.</CardDescription>
            </CardHeader>
            <CardContent>
              <Button asChild variant="outline" className="w-full">
                <Link to="/advogados">Ver advogados</Link>
              </Button>
            </CardContent>
          </Card>
        </div>

        <h2 className="font-serif text-2xl mt-12 mb-4">Tarefas em andamento</h2>
        <Card>
          <CardContent className="pt-6 text-muted-foreground text-sm">
            Você ainda não tem tarefas. Quando contratar um advogado, ela aparecerá aqui.
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
